/* Plush-Lined Skate Sneaker store — small, self-contained enhancements.
   Does not touch Shrine's product-form / variant-selects / cart internals. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- rails: arrows that wrap around ---------- */
  function initRails(root) {
    root.querySelectorAll('[data-io-rail]').forEach(function (rail) {
      if (rail.dataset.ioReady) return;
      rail.dataset.ioReady = '1';
      var scope = rail.closest('section') || rail.parentNode;
      var track = rail.querySelector('.io-rail__track');
      if (!track) return;
      function step() {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function go(dir) {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); return; }
        track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      }
      scope.querySelectorAll('[data-io-prev]').forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
      scope.querySelectorAll('[data-io-next]').forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
    });
  }

  /* ---------- inside / outside x-ray ---------- */
  function initXray(root) {
    root.querySelectorAll('[data-io-xray]').forEach(function (stage) {
      var range = stage.querySelector('[data-io-xray-range]');
      if (!range || range.dataset.ioReady) return;
      range.dataset.ioReady = '1';
      var section = stage.closest('section');
      var lists = section ? section.querySelectorAll('.io-xray__list') : [];
      function set(v) {
        stage.style.setProperty('--x', v + '%');
        lists.forEach(function (l) {
          var side = l.getAttribute('data-side');
          l.classList.toggle('is-active', (side === 'inside' && v >= 60) || (side === 'outside' && v <= 40));
        });
      }
      range.addEventListener('input', function () { set(range.value); });
      set(range.value);
      // gentle one-time hint when it scrolls into view
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            var t0 = null, from = 50;
            function frame(t) {
              if (!t0) t0 = t;
              var p = Math.min((t - t0) / 1600, 1);
              var v = from + Math.sin(p * Math.PI * 2) * 22 * (1 - p);
              if (range.dataset.ioTouched) return;
              range.value = v; set(v);
              if (p < 1) requestAnimationFrame(frame);
            }
            requestAnimationFrame(frame);
          });
        }, { threshold: 0.6 });
        io.observe(stage);
        range.addEventListener('pointerdown', function () { range.dataset.ioTouched = '1'; });
      }
    });
  }

  /* ---------- lace styles tabs ---------- */
  function initLaces(root) {
    root.querySelectorAll('[data-io-laces]').forEach(function (sec) {
      if (sec.dataset.ioReady) return;
      sec.dataset.ioReady = '1';
      var tabs = sec.querySelectorAll('[data-io-lace-tab]');
      function select(tab) {
        var style = tab.getAttribute('data-io-lace-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        sec.querySelectorAll('[data-io-lace-panel]').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        var idx = Array.prototype.indexOf.call(tabs, tab);
        sec.querySelectorAll('[data-io-lace-art]').forEach(function (a, i) { a.classList.toggle('is-active', i === idx); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); select(n);
        });
      });
    });
  }

  /* ---------- buy box helpers ---------- */
  function buyBox() {
    return document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product__info-container') || document.getElementById('MainContent');
  }
  function scrollToBuy() {
    var el = buyBox();
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }
  function initBuyScroll(root) {
    root.querySelectorAll('[data-io-buy-scroll]').forEach(function (a) {
      if (a.dataset.ioReady) return;
      a.dataset.ioReady = '1';
      a.addEventListener('click', function (e) {
        if (!document.querySelector('[id^="ProductInfo-"]')) return; // not on a product page: follow the link
        e.preventDefault();
        scrollToBuy();
      });
    });
  }

  /* ---------- fit finder ---------- */
  function sizeNumber(s) { var m = String(s).match(/\d+(?:[.,]\d+)?/); return m ? m[0].replace(',', '.') : ''; }
  function initFit(root) {
    root.querySelectorAll('[data-io-fit]').forEach(function (sec) {
      if (sec.dataset.ioReady) return;
      sec.dataset.ioReady = '1';
      var range = sec.querySelector('[data-io-fit-range]');
      var cm = sec.querySelector('[data-io-fit-cm]');
      var out = sec.querySelector('[data-io-fit-size]');
      var hint = sec.querySelector('[data-io-fit-hint]');
      var wide = sec.querySelector('[data-io-fit-wide]');
      var socks = sec.querySelector('[data-io-fit-socks]');
      var pick = sec.querySelector('[data-io-fit-pick]');
      var rows = Array.prototype.slice.call(sec.querySelectorAll('[data-io-fit-row]'));
      if (!range || !rows.length) return;
      var current = null;
      function update() {
        var v = parseFloat(range.value);
        cm.textContent = v.toFixed(1).replace('.', ',') + ' cm';
        var idx = -1;
        rows.forEach(function (r, i) {
          if (v >= parseFloat(r.dataset.min) - 0.05 && v <= parseFloat(r.dataset.max) + 0.05) idx = i;
        });
        if (idx === -1) idx = v < parseFloat(rows[0].dataset.min) ? 0 : rows.length - 1;
        var up = (wide && wide.checked) || (socks && socks.checked);
        var target = idx + (up ? 1 : 0);
        var outOfRange = target > rows.length - 1 || v > parseFloat(rows[rows.length - 1].dataset.max) + 0.05 || v < parseFloat(rows[0].dataset.min) - 0.3;
        target = Math.min(target, rows.length - 1);
        rows.forEach(function (r, i) { r.classList.toggle('is-match', i === target); });
        current = rows[target].dataset.size;
        out.textContent = current;
        hint.textContent = outOfRange ? hint.dataset.out : (up ? hint.dataset.up : hint.dataset.base);
        if (pick) pick.textContent = (pick.dataset.label || '[size] wählen').replace('[size]', current);
      }
      [range, wide, socks].forEach(function (el) { if (el) { el.addEventListener('input', update); el.addEventListener('change', update); } });
      update();
      if (pick) pick.addEventListener('click', function () {
        var want = sizeNumber(current);
        var inputs = document.querySelectorAll('variant-selects input[type="radio"], variant-selects select option');
        var hit = null;
        inputs.forEach(function (i) {
          if (hit) return;
          var val = i.value || i.textContent;
          if (val === current || (want && sizeNumber(val) === want && /\b(eu|size)?\s*\d/i.test(val))) hit = i;
        });
        if (hit) {
          if (hit.tagName === 'OPTION') {
            var sel = hit.parentNode; sel.value = hit.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (!hit.checked) {
            var label = document.querySelector('label[for="' + hit.id + '"]');
            (label || hit).click();
          }
        }
        scrollToBuy();
      });
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('.io-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init(root) {
    root = root || document;
    try { initRails(root); } catch (e) { console.warn(e); }
    try { initXray(root); } catch (e) { console.warn(e); }
    try { initLaces(root); } catch (e) { console.warn(e); }
    try { initBuyScroll(root); } catch (e) { console.warn(e); }
    try { initFit(root); } catch (e) { console.warn(e); }
    try { initReveal(root); } catch (e) { console.warn(e); }
  }

  ready(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
